










import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Statistics } from "../../models/statistics.model";

const countTo = require("vue-count-to").default;

@Component({
  name: "AppStatisticsCounter",
  components: { countTo }
})
export default class AppStatisticsCounter extends Vue {
  @Prop({ default: "" }) headline: string;
  @Prop({ default: 0 }) endVal!: number;
  @Prop({ default: 4000 }) duration!: number;
  @Prop({ default: "" }) iconClass!: string;
}
